import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { AddQueueDialogComponent } from 'src/app/core/dialogs/add-queue-dialog/add-queue-dialog.component';
import { BtnCellRenderer } from 'src/app/core/grid/btn-cell-render.component';
import { ExcelService } from 'src/app/service/excel.service';
import { GroupIStateService } from 'src/app/service/groupi-state.service';
import { AssignedUserService } from 'src/app/service/kpi/assigned-user.service';
import { DomicileService } from 'src/app/service/kpi/domicile.service';
import { FormControl } from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { startWith, map } from 'rxjs/operators';

@Component({
    selector: 'app-assigned-user',
    templateUrl: './assigned-user.component.html',
    styleUrls: ['./assigned-user.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None 
})
export class AssignedUserComponent implements OnInit {
  columnDefs;
  rowData;
  baseRowData: {}[];
  gridApi: any;
  currentPageNo: any;
  currentPageBoolean: boolean;
  rowCount: any;
  isLastPageFound: boolean;
  totalPage: any;
  currentPageForTotalPage: number;
  context: any;
  frameworkComponents: { btnCellRenderer: any; };
  icons: {};
  defaultColDef;
  displayRowData: any;
  updatedRows: any[];
  toprow: any;
  selectedUsers = []

  gridColumnApi: any;
  selected_position_id: number;
  selected_round_id: number;
  RoundData: any;
  TierData = [];
  selectedPeriod: any;
  successMessage = "";
  errorMessage = "";
  optionalUsers: any;
  isAccessible = false;
  temp1: any;
  KPI_WidgetsData = {
    id_TierPosition: null,
    id_Round: null,
    list_Domiciles: null,
    list_Users: null
  }
  tempdat: any;
  userFilterCtrl: FormControl = new FormControl();
filteredUsers: ReplaySubject<any[]> = new ReplaySubject(1);


  constructor(private readonly router: Router, public dialog: MatDialog, private readonly excelService : ExcelService, private readonly constants: Constants,
    private readonly domicileService: DomicileService, private readonly assignedUser: AssignedUserService, private readonly groupIStateService : GroupIStateService,
    private readonly ngxUiLoaderService : NgxUiLoaderService) {
    this.context = {
      componentParent: this
    };
    this.frameworkComponents = {
      btnCellRenderer: BtnCellRenderer
    };
    const tempKPI_WidgetsData = localStorage.getItem('KPI_WidgetsData');
    if (tempKPI_WidgetsData) {
      this.KPI_WidgetsData = JSON.parse(tempKPI_WidgetsData);
    }
  }

  ngOnInit(): void {
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    this.defaultColDef = {
      minWidth: 100,
      wrapText: true, resizable: true,
      floatingFilter: true, suppressMovable: true,suppressHeaderFilterButton: true ,suppressCellSelection: true
    };
    this.getColumnDefs()
    this.selectedPeriod = Number(localStorage.getItem("selectedPeriodId"))

    // this.checkRoles();
    this.userFilterCtrl.valueChanges
  .pipe(
    startWith(''),
    map(search => search ? this.filterUsers(search) : this.selectedUsers?.slice())
  )
  .subscribe(filtered => {
    this.filteredUsers.next(filtered);
  });
  this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }
  async checkRoles() {
    await this.groupIStateService.getRoles();
    const roles = this.groupIStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
    //   if (userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin))
    //     this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // }
  }

  private filterUsers(search: string): any[] {
    const filterValue = search.toLowerCase();
    return this.selectedUsers.filter(user => user.label.toLowerCase().includes(filterValue));
  }


  defaultRowData() {

    this.toprow = [];
    this.displayRowData = [];
    this.gridApi?.setGridOption('rowData', this.displayRowData)
    this.updatedRows = [];
    this.rowCount = this.displayRowData.length;
  }

  IDValueFormatter(params) {
    let displayValue;

    if (params.data?.ALARM_ID == "null")  // NOSONAR
      {displayValue = "";}
    else
      {displayValue = params.data?.ALARM_ID;}

    return displayValue;
  }

  getColumnDefs() {
    this.columnDefs = [
      {
        headerName: "ID", field: "ALARM_ID", minWidth: 55, maxWidth: 55, floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter', pinned: 'left', autoHeight: true, valueFormatter: this.IDValueFormatter
      },
      {
        headerName: "Alarm", field: "ALARM", minWidth: 500, maxWidth: 500, cellClass: "left_align",
        autoHeight: true, pinned: 'left'
      },
      // {
      //   headerName: "Total_user", field: "'TOTAL_USER'", minWidth: 120, maxWidth: 120,
      //   autoHeight: true, pinned: 'left'
      // },
      {
        headerName: "Total", field: "TOTAL", minWidth: 120, maxWidth: 120,
        autoHeight: true, pinned: 'left'
      }
    ];
  }

  onTierChange() {
    if (this.selected_position_id > 0) {
      this.KPI_WidgetsData.id_TierPosition = Number(this.selected_position_id)
      localStorage.setItem('KPI_WidgetsData', JSON.stringify(this.KPI_WidgetsData));
      this.ngxUiLoaderService.start(this.constants.LoaderComponent);
      this.domicileService.getRoundList(this.selectedPeriod, this.selected_position_id).subscribe(
        response => {
          this.selected_round_id = null
          this.RoundData = response;
          if (response.length > 0) {
            this.selected_round_id = this.RoundData[0];
            this.selected_round_id = Number(this.KPI_WidgetsData.id_Round) > 0 ? Number(this.KPI_WidgetsData.id_Round) : 1
            this.onRoundChange();
          } else {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
            this.defaultRowData()
          }
        }, _error => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
          this.errorMessage = this.constants.APIErrorMessage;
          this.defaultRowData()
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      );
    }
  }



  onRoundChange() {
    if (this.selected_round_id) {
      this.KPI_WidgetsData.id_Round = Number(this.selected_round_id)
      localStorage.setItem('KPI_WidgetsData', JSON.stringify(this.KPI_WidgetsData));
    }
    this.getUsers()
  }

  getUsers() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    this.assignedUser.getUserList(Number(this.selectedPeriod)).subscribe(
      response => {
        this.selectedUsers = [];
        if (response.length > 0) {
          const temp = response
          temp.forEach(element => {
           const obj = { "label": element.strfirstname, "value": element.intuserid };
            this.selectedUsers.push(obj);
          });

          this.optionalUsers = this.selectedUsers
          const tempOptionalUsers = this.KPI_WidgetsData.list_Users?.split(",")
          if (tempOptionalUsers) {
            const tempFinalOptionalUsers = []
            tempOptionalUsers.forEach(element => {
              const objOptionalDomicile = this.optionalUsers.find(x => x.label == element)  // NOSONAR
              if (objOptionalDomicile)
               { tempFinalOptionalUsers.push(objOptionalDomicile)}

            })
            this.optionalUsers = tempFinalOptionalUsers
          }
          this.onUsersChange();
        }
        else {
          this.defaultRowData()
          this.getColumnDefs()
          this.onUsersChange()
        }
        this.filteredUsers.next(this.selectedUsers?.slice());
      },
      _error => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
        this.errorMessage = this.constants.APIErrorMessage;
        this.getColumnDefs()
        this.defaultRowData()
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTime);
      }

    )
  }

  RefreshData() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    this.assignedUser.getGridData(this.selectedPeriod, this.selected_position_id, Number(this.selected_round_id), this.optionalUsers?.map(x => x.value).toString()).subscribe(
    response => {
    if (response.length > 0) {
    this.temp1 = JSON.parse(response)
    this.displayRowData = JSON.parse(JSON.stringify(this.temp1))
    this.toprow = [];
    for (let i = 0; i < 2; i++) {
    this.toprow.push(this.displayRowData[i]);
    }
          this.toprow[1].TOTAL = this.toprow[1].TOTAL == "00%" || this.toprow[1].TOTAL == "0%" ? "0.00%" : this.toprow[1].TOTAL  // NOSONAR
    this.optionalUsers?.forEach(element => {
    this.toprow.forEach(x => { x[`'${element.value}'`] = x[`'${element.value}'`] == "00%" || x[`'${element.value}'`] == "0%" ? "0.00%" : x[`'${element.value}'`] })  // NOSONAR
    });
    this.displayRowData.splice(0, 2)
    this.gridApi?.setGridOption('rowData', this.displayRowData)
    this.updatedRows = [];
    this.rowCount = this.displayRowData.length;
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
    } else {
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
    this.defaultRowData()
    }
      }, _error => {
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
    this.errorMessage = this.constants.APIErrorMessage;
    this.defaultRowData()
    setTimeout(() => {
    this.successMessage = "";
    this.errorMessage = "";
    }, this.constants.notificationMessageTime);
    }
    )
  }

  onUsersChange() {

    this.columnDefs = []
    this.KPI_WidgetsData.list_Users = this.optionalUsers?.map(x => x.label).toString()
    localStorage.setItem('KPI_WidgetsData', JSON.stringify(this.KPI_WidgetsData));
    this.getColumnDefs()
    this.optionalUsers?.forEach(element => {
      const obj = { headerName: element.label, field: "'" + element.value + "'", minWidth: 200, sortable: true, unSortIcon: true, autoHeight: true }
      this.columnDefs.push(obj);
    })
    // }
    this.RefreshData()
  }

  OnGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }
  sizeToFit() { this.gridApi.sizeColumnsToFit(); }
  SizeToFit() { this.gridApi?.sizeColumnsToFit(); }
  OnPageSizeChanged(event: any) {
    if (event.target.value == "ALL")  // NOSONAR
      {this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length));}
    else
      {this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));}
  }
  GoToNexpage() { this.gridApi.paginationGoToNextPage(); }

  GoToPreviousPage() { this.gridApi.paginationGoToPreviousPage()  }

  GoToFirstPage() { this.gridApi.paginationGoToFirstPage(); }

  GoToLastPage() { this.gridApi.paginationGoToLastPage()  }

  GetCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) {  // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }

  IsLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {  // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }

  AddToQueue(): void {
    const dialogRef = this.dialog.open(AddQueueDialogComponent, {
      disableClose: true,
      width: '500px',
      height: '240px',
      data: {
        header: 'Add To Queue',
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      if (result.event == 'SaveEvent') {  // NOSONAR
        if (result.data == "Success") {  // NOSONAR
          this.successMessage = this.constants.APIAddToQueueSuccess;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      }
    });

  }
  onBtExport() {
    if (this.temp1?.length > 0) {
      const exportData = [];
      let obj;
      this.temp1.forEach(e => {
        obj = {
          id: e.ALARM_ID,
          alarm: e.ALARM,
          total: e.TOTAL
        };

        this.selectedUsers?.forEach(element => {
          obj[element.label] = e[`'${element.value}'`]
        });

        exportData.push(obj);
      });
      const headers = ['ID', 'ALARM', 'TOTAL'];
      this.selectedUsers.forEach(e => {
        headers.push(e.label);
      })

      this.excelService.exportAsExcelFile(exportData, 'ASSIGNED-USER-KPI - ' + localStorage.getItem("selectedPeriodValue"), headers);
    }
  }

  componentEventHandler(event) {

    if (event.eventType == "CHANGE_PERIOD") {  // NOSONAR
      this.selectedPeriod = event.periodId


      if (this.selectedPeriod) {
        this.ngxUiLoaderService.start(this.constants.LoaderComponent);
        this.domicileService.getTierList(this.selectedPeriod).subscribe(
          response => {
            this.selected_position_id = null;
            this.TierData = response;
            if (response.length > 0) {
              this.selected_position_id = this.TierData[0].tierPosition;
              this.selected_position_id = Number(this.KPI_WidgetsData.id_TierPosition) > 0 ? Number(this.KPI_WidgetsData.id_TierPosition) : 1
              this.onTierChange()


            }
            else {
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
              this.defaultRowData()
            }
          },
          _error => {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
            this.errorMessage = this.constants.APIErrorMessage;
            this.defaultRowData()
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTime);
          }
        );
      }
    }
  }


  openRouteLevel(route) {
    this.router.navigate([`${route}`]);
  }

  isAllSelected(): boolean {
    return this.optionalUsers?.length == this.selectedUsers?.length;  // NOSONAR
  }
  
  isIndeterminate(): boolean {
    return this.optionalUsers?.length > 0 &&
           this.selectedUsers?.length > 0 &&
           this.selectedUsers?.length < this.optionalUsers?.length;
  }
  
  toggleSelectAll(event: any): void {
    if (event.checked) {
      this.optionalUsers = [...this.selectedUsers];
    } else {
      this.optionalUsers = [];
    }
    this.onUsersChange(); 
  }
  

}
